import { render, staticRenderFns } from "./getreport.vue?vue&type=template&id=3ffe75f4&"
import script from "./getreport.vue?vue&type=script&lang=js&"
export * from "./getreport.vue?vue&type=script&lang=js&"
import style0 from "./getreport.vue?vue&type=style&index=0&id=3ffe75f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports